<div class="lokos-input lokos-date-picker">
    @if (label) {
        <mat-label>
            {{ label | translate }}
            <span class="required">{{ required ? '*' : '' }}</span>
        </mat-label>
    }
    <mat-form-field
        appearance="outline"
        [ngClass]="readonly ? 'mat-mdc-form-field-disabled' : ''"
    >
        <input
            matInput
            [matDatepicker]="datepicker"
            [placeholder]="placeholder | translate"
            [formControl]="control"
            [max]="maxDate"
            [min]="minDate"
            [required]="required"
            [value]="value"
            (focus)="afterFocus.emit($event)"
            (dateChange)="afterDateChange.emit($event)"
            [readonly]="readonly"
            [matDatepickerFilter]="matDatepickerFilter"
        />
        <mat-datepicker-toggle
            matIconSuffix
            [for]="datepicker"
            [disabled]="readonly"
            [disableRipple]="true"
        >
            <img
                class="img-toggle"
                matDatepickerToggleIcon
                [src]="
                    theme === 'dark'
                        ? 'assets/images/calendarDark.svg'
                        : 'assets/images/calendarLight.svg'
                "
                alt="calendarLight.svg"
            />
        </mat-datepicker-toggle>
        <mat-datepicker
            #datepicker
            [startView]="startView"
            [startAt]="startAt || lastSelectedMonth"
            [panelClass]="
                panelClass || (startView === 'year' ? 'month-picker' : '')
            "
            (monthSelected)="onMonthSelectEmit($event, datepicker)"
            (yearSelected)="OnYearSelected($event, datepicker)"
        >
        </mat-datepicker>
    </mat-form-field>
    <div class="lokos-date-picker-error-wrapper">
        @if (control.invalid && (control.dirty || control.touched)) {
            <mat-error class="lokos-date-picker-error">{{
                getErrorMessage()
            }}</mat-error>
        }
    </div>
</div>
